import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ParametrizacionRoutingModule } from './parametrizacion-routing.module';
import { ModalOrigenPiloto, ParametrizacionComponent } from './components/parametrizacion/parametrizacion.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { CompanyPipe } from './pipes/company.pipe';

@NgModule({
  declarations: [
    ParametrizacionComponent,
    ModalOrigenPiloto,
    CompanyPipe
  ],
  imports: [
    CommonModule,
    ParametrizacionRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ImportsModule
  ]
})
export class ParametrizacionModule { }
